import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Paginator } from 'front-onceforall-core';
import RequestRow from '../requestRow';
import CreateRequestForApprovalButton from '../buttons/createRequestForApprovalButton';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const RequestListView = props => {
  const rows = props.organisations && props.invitations ? props.requests.map(request => {
    return /*#__PURE__*/_jsx(RequestRow, {
      history: props.history,
      request: request,
      organisations: props.organisations,
      invitations: props.invitations
    }, request.id);
  }) : false;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.loading && /*#__PURE__*/_jsx("div", {
      className: "loading-overlay"
    }), rows.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [rows, /*#__PURE__*/_jsx(Paginator, {
        totalItems: props.requestsTotalCount,
        pageSize: props.pageSize,
        currentPage: props.pageNumber,
        onChangePage: props.onPageChange
      })]
    }), rows.length === 0 && /*#__PURE__*/_jsx("div", {
      className: "table-without-result",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex-container column center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "no-request-message mb-5",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "request.noRequest"
          })
        }), /*#__PURE__*/_jsx(CreateRequestForApprovalButton, {
          icon: "folder-plus"
        })]
      })
    })]
  });
};
RequestListView.propTypes = {
  history: PropTypes.object.isRequired,
  organisations: PropTypes.array.isRequired,
  requests: PropTypes.array.isRequired,
  requestsTotalCount: PropTypes.number.isRequired,
  invitations: PropTypes.array,
  onPageChange: PropTypes.func.isRequired,
  pageNumber: PropTypes.number,
  pageSize: PropTypes.number,
  loading: PropTypes.bool.isRequired
};
RequestListView.defaultProps = {
  pageNumber: 0,
  pageSize: 10,
  invitations: []
};
export default withRouter(RequestListView);